import React, { useState, useEffect, useGlobal, useCallback } from 'reactn';
import { DeliveryItemCardStyled } from './DeliveryItemCardStyled';
import logoImage from "../../../images/defaultLogo.svg";
import deliveryHooks from "../../../hooks/deliveryHooks";
import { ReactComponent as CustomsAlert } from '../../../images/customsAlert.svg';
import { ReactComponent as InformIcon } from '../../../images/informIcon.svg';
import { getTrackingHistory } from '../../../services/Api';
import CurrentStatusPill from '../currentStatusPill';
import profileHooks from '../../../hooks/profileHooks';
import Icon from '../icons/ReturnIcons';
import { formatDateItemCard, formatTrackingNumber } from '../../../helpers/Helpers';

const RETAILER_IMAGE_BASE_URL = window.appMyDeliveriesRetailerImageUrl;

const DeliveryItemCard = ({ history, selected, handleSelected, isExtended, trackingItem, isSending }) => {
    const [companyImageUrl, setCompanyImageUrl] = useState(logoImage);

    const handleCompanyImage = (retailerId) => {
        const imageUrl = `${RETAILER_IMAGE_BASE_URL}/${retailerId}.svg`;
        const fallbackUrl = logoImage;
        
      
        return new Promise((resolve) => {
          const img = new Image();
          img.src = imageUrl;
          img.onload = () => resolve(imageUrl);
          img.onerror = () => resolve(fallbackUrl);
        });
      };

      useEffect(() => {
        if (trackingItem && trackingItem.retailerId) {
          handleCompanyImage(trackingItem.retailerId).then(setCompanyImageUrl);
        }
      }, [trackingItem]);

    function formatDateWithLeadingZeros(dateObject) {
            let day = dateObject.getDate();
            let month = dateObject.getMonth() + 1; 
            let year = dateObject.getFullYear();
          
            // Add leading zeros to day and month if necessary
            day = day.toString().padStart(2, '0');
            month = month.toString().padStart(2, '0');
          
            // Return the formatted date
            return `${day} ${month} ${year}`;
      }


    const { getDeliveryStatusInfo } = deliveryHooks();

    const handleParentStateSelected = useCallback(() => {
        handleSelected(trackingItem);
    }, [handleSelected, trackingItem.trackingNumber]);

    let deliveryExtraInfo = "";

    switch (trackingItem.lastTrackingEventCategoryId) {
        case "0": 
            if(trackingItem.estimatedDeliveryDateTime) {
                deliveryExtraInfo = `Time until Delivery: ${trackingItem.estimatedDeliveryDateTime}`;
            } else {
                deliveryExtraInfo = "";
            }
            break;

        case "1": 
            if(trackingItem.customsPaymentRequired) {
                const date = new Date(trackingItem.customsPaymentDateDue);
                deliveryExtraInfo = `Pay Customs charges by ${formatDateWithLeadingZeros(date)}`;
            } else {
                deliveryExtraInfo = "";
            }
            break;
        case "2": 
            if(trackingItem.deliveryManagerAvailable) {
                deliveryExtraInfo = `Manage delivery`;
            } else {
                deliveryExtraInfo = "";
            }
         break;   
        case "3": 
                deliveryExtraInfo = "";
            break;
        case "4": 
            if(trackingItem.dateDelivered) {
                const date = new Date(trackingItem.dateDelivered);
                deliveryExtraInfo = `Delivered on ${formatDateItemCard(date)}`;
            } else {
                deliveryExtraInfo = "";
            }    
    
        default:
            break;
    }

 

    return (
        <DeliveryItemCardStyled
            onClick={handleParentStateSelected}
            selected={selected}
            extended={isExtended}
            statusColor={getDeliveryStatusInfo(trackingItem.lastTrackingEventCategoryId).statusClass}
        >
            <div className='primaryField'>
                <div className='retailerInfoCard'>
                    <div className='imagesWrapper'>
                        <img src={companyImageUrl} alt='retailer logo' />
                        {trackingItem.lastTrackingEventCategoryId === "1" && deliveryExtraInfo !== ""  &&  <div className='customsAlert'> <Icon src='customsIcon' /> </div>}
                        {trackingItem.lastTrackingEventCategoryId === "2" &&  deliveryExtraInfo !== ""  && <div className='customsAlert'> <InformIcon /> </div>}
                    </div>
                    <div>
                        {!isSending && <div className='retailerNameHolder'>{trackingItem.retailerName}</div>}
                        {isSending && <div className='retailerNameHolder'>{trackingItem.retailerId  ? trackingItem.retailerName : trackingItem.recipientName}</div>}
                        <div className='itemNameHolder'>{formatTrackingNumber(trackingItem.trackingNumber)}</div>
                    </div>
                    {isExtended && <div className='secondaryFieldExtended'>
                        {trackingItem.lastTrackingEventCategoryId === "1" && deliveryExtraInfo !== ""  &&  <div className='customsAlertExtended'> <Icon src='customsIcon' /> </div>}
                        {trackingItem.lastTrackingEventCategoryId === "2" && deliveryExtraInfo !== ""  && <div className='customsAlertExtended'> <InformIcon /> </div>}
                        {trackingItem.lastTrackingEventCategoryId === "4" && deliveryExtraInfo !== ""  && <div className='description' > {deliveryExtraInfo}</div>}
                        {/* <div className='description'>Time until Delivery: here</div> */}
                    </div>}
                </div>
                <CurrentStatusPill selected={selected} trackingItem={trackingItem} />

            </div>
            {!isExtended && <div className='secondaryField'>
                <div>{deliveryExtraInfo}</div>
            </div>}
        </DeliveryItemCardStyled>
    );
};

export default React.memo(DeliveryItemCard);
